import React, { forwardRef } from 'react';
import styled from 'styled-components';
import { space } from '@design/templateFns';
import { ChevronLeft, ChevronRight } from '@icon/Chevrons';
import { button, light, dark } from '@design/variants/buttonsCarousels';

//
//
// Wrapper style that can be re-used for any carousel
//
export const CarouselNavButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: ${space('sm')};
  margin-top: ${space('x6')};

  @media only screen and (min-width: 580px) {
    display: none;
  }
`;

//
//
// Nav Buttons
//
export type NavButtonVariants = // Fork from the @components/Button/
  'button' | 'light' | 'dark';

interface CarouselNavButtonProps {
  variant?: NavButtonVariants;
  color?: string;
  hoverColor?: string;
  className?: string; // if you want to pass a className to the button
}

const StyledCarouselNavButton = styled.button<{ $variant: NavButtonVariants }>`
  ${({ $variant }) => ($variant === 'light' ? light : $variant === 'dark' ? dark : button)},

  svg {
    display: block;
    width: 14px; //non-standard sizing because of svg rendering within button
    height: 14px;
    box-sizing: border-box;
  }
`;

export const CarouselNavButtonLeft = forwardRef<HTMLButtonElement, CarouselNavButtonProps>(
  ({ variant = 'button', className }, ref) => {
    return (
      <StyledCarouselNavButton
        data-testid="carousel-nav-prev"
        type="button"
        ref={ref}
        $variant={variant}
        className={className}
      >
        <ChevronLeft />
      </StyledCarouselNavButton>
    );
  },
);

export const CarouselNavButtonRight = forwardRef<HTMLButtonElement, CarouselNavButtonProps>(
  ({ variant = 'button', className }, ref) => {
    return (
      <StyledCarouselNavButton
        data-testid="carousel-nav-next"
        type="button"
        ref={ref}
        $variant={variant}
        className={className}
      >
        <ChevronRight />
      </StyledCarouselNavButton>
    );
  },
);
